import { IDocumentData } from '@models/document/IDocumentData';
import { IDocumentScheme } from '@models/document/IDocumentScheme';
import { Variant } from '@srm/ui/types/ColorVariants';
import type { IOption } from '@srm/ui/types/IOption';

export interface ITreeOption extends IOption {
    /** Optional Root.xml grouping; adjacent groups are separated without headings. */
    groupId?: string;
    placement?: 'main' | 'footer';
    checked?: boolean;
    hasCheckedChild?: boolean;
    parent?: ITreeOption;
    children?: ITreeOption[];
    variant?: Variant;
    loading?: boolean;
    hasChildren?: boolean;
    /** Описание пункта (вторая строка в хабе раздела; дашборды — из манифеста). */
    description?: string;
    /** Показывать бейдж-счётчик для пункта меню. Приходит из FolderTreeNodeDto.counter. */
    counter?: boolean;
    /** Ключ запроса счётчика (== templateName). Пустой — бейдж не рисуется. */
    countKey?: string;
    /** Порог "{N}+" для отображения. Если не задан — клиент берёт maxDisplayValue из config. */
    counterMax?: number;
    /**
     * Режим счётчика из XML (`counterMode`, по умолчанию push): `off` — счётчик не запрашивается и не рисуется.
     * `poll` фронт не поддерживает и обновляет такой счётчик как push.
     */
    counterMode?: 'push' | 'poll' | 'off';
    /**
     * Flow IDs, к которым привязан счётчик (из парсинга rc_FlowName на бэке).
     * useFolderCounts на CountersInvalidated(flowKey) рефетчит только те counter'ы,
     * где flowKey попадает в этот массив или он отсутствует/пустой (catch-all).
     */
    counterFlowKeys?: number[];
}

/** Контекст создания документа через модальное окно */
export interface IDocumentModalContext {
    data?: IDocumentData;
    scheme?: IDocumentScheme;
}

/** Форматированная дата */
export interface IFormattedDate {
    month: string;
    monthLong: string;
    monthShort: string;
    monthName: string;
    dayOfMonth: string;
    dayOfWeek: string;
    hour: string;
    minutes: string;
    year: number;
    date: string;
    time: string;
}

export enum YearsShowType {
    AllYears,
    CurrentYear,
}
